export default __webpack_public_path__ + "static/media/contact.e258dd70.svg";